// extracted by mini-css-extract-plugin
export var bottomCircle = "bK_hm";
export var content = "bK_bQ";
export var description = "bK_dv";
export var hide = "bK_B";
export var icon = "bK_bv";
export var image = "bK_g";
export var imageContainer = "bK_hr";
export var left = "bK_bL";
export var nextYear = "bK_hq";
export var right = "bK_bX";
export var section = "bK_d";
export var shrink = "bK_hp";
export var title = "bK_h";
export var topCircle = "bK_hl";
export var wave = "bK_fG";
export var waveContainer = "bK_d7";
export var year = "bK_hn";